import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { ConfirmationService } from '../../core/services/confirmation';

@Component({
  selector: 'app-confirmation',
  imports: [CommonModule],
  templateUrl: './confirmation.html',
  styleUrl: './confirmation.scss',
})
export class ConfirmationComponent implements OnInit {

  confirmation = inject(ConfirmationService);
  ngOnInit(): void {
    // Prevent page scrolling while dialog is open
    this.confirmation.modal$.subscribe(modal => {
      if (typeof document === 'undefined')
        return;

      document.body.style.overflow = modal
        ? 'hidden' : '';
    });
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.confirmation.cancel();
  }

}